export const getPageOffset = (currPage: number, limit: number) => {
  let pageOffset = currPage - 1

  if (pageOffset < 0) pageOffset = 0
  return pageOffset * limit
}
